/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RoutingPredicate } from './routingPredicate';

export interface SelectionRuleIn {
  stage_ids?: string[] | null;
  title_keywords?: string[] | null;
  property_predicate?: RoutingPredicate | null;
  ats_interview_kit_name?: string | null;
}
